import { useState } from "react";

import { makePostApiCall, makePutApiCall } from "../../shared/makeApiCall";
import { useToast } from "../../contexts/ToastContext";

import DeleteConfirmationForm from "../../components/forms/DeleteConfirmationForm";
import ImportMediaCsvDropzone from "../../components/importMedia/ImportMediaCsvDropzone";
import LoblawsSkuForm from "../../components/forms/setup/loblawsSku/LoblawsSkuForm";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";

export function LoblawsSkusViewModel(logout) {
  const { showSuccess } = useToast();
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [skus, setSkus] = useState({ data: [] });

  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const getSkus = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
    };
    let callResult = await makePostApiCall(`loblawsSkus`, payload);
    setLoading(false);
    if (callResult.success) {
      setSkus(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const createSku = async function (values) {
    const payload = { ...values };
    let callResult = await makePostApiCall("createLoblawsSku", payload);

    if (callResult.success) {
      showSuccess(
        callResult.data.message || "Action completed"
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getSkus("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const updateSku = async function (sku, values, index) {
    let callResult = await makePutApiCall(`loblawsSkus/${sku.id}`, values);

    if (callResult.success) {
      showSuccess(
        callResult.data.message || "Action completed"
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getSkus("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const openAddSkuSlideOver = () => {
    setSlideOver({
      childComponent: (
        <LoblawsSkuForm
          isEdit={false}
          setOpen={setSlideOver}
          actionCall={createSku}
        />
      ),
      open: true,
    });
  };

  const viewSkuDetails = async function (sku, index) {
    setSlideOver({
      childComponent: (
        <LoblawsSkuForm
          sku={sku}
          index={index}
          isEdit={true}
          setOpen={setSlideOver}
          actionCall={updateSku}
        />
      ),
      open: true,
    });
  };

  const deleteLoblawsSku = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteLoblawsSku/${id}`, {});
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      getSkus(null, 0);
      showSuccess(
        callResult.data.message || "Action completed"
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const askdeleteLoblawsSku = function (sku, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteLoblawsSku(sku.id, index)}
          message={`Are you sure you want to delete  ${sku.loblaws_sku}?`}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  const importLoblawsSkus = async function (uploadedFile) {
    const { name, value } = uploadedFile.target;
    const payload = { [name]: value };
    let callResult = await makePostApiCall(
      "importLoblawsSkus",
      payload,
      "multipart/form-data"
    );

    if (callResult.success) {
      getSkus("", 1);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showErrorModal(callResult.data.message);
    }
  };

  const openImportOrder = () => {
    setEmptyModelOpen({
      childComponent: (
        <ImportMediaCsvDropzone
          fileName="orderCsv"
          actionCall={importLoblawsSkus}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  return {
    askdeleteLoblawsSku,
    emptyModal,
    getSkus,
    loading,
    skus,
    openAddSkuSlideOver,
    setEmptyModelOpen,
    setSlideOver,
    slideOver,
    viewSkuDetails,
    openImportOrder,
  };
}
